import { subscribe } from 'shared/store'

import { SCROLL_TO_TOP } from 'shared/store/ducks/events'

import toggleBoolStringAttr from 'views/utils/toggleBoolStringAttribute'

import { ARIA_HIDDEN } from './consts'

export default () => {
  const OFFSET_TOP = 150

  /** @type HTMLElement */
  const scrollButton = document.querySelector(
    '[data-clientside-hook~="ScrollToTop__button"]'
  )
  const { pageYOffset } = window

  let lastKnownScrollPosition = 0
  let ticking = false
  let timeout = setTimeout(() => {}, 1e6)

  const getScrollElement = () => {
    if ('scrollingElement' in document) {
      return document.scrollingElement
    }
    // Fallback for legacy browsers
    if (navigator.userAgent.indexOf('WebKit') !== -1) {
      return document.body
    }
    return document.documentElement
  }

  const toggleScrollButton = scrollPosition => {
    toggleBoolStringAttr(scrollButton, ARIA_HIDDEN, scrollPosition < OFFSET_TOP)
  }

  const scrollEventCallback = () => {
    if (!ticking) {
      ticking = true
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        lastKnownScrollPosition = window.pageYOffset
        toggleScrollButton(lastKnownScrollPosition)
        ticking = false
      }, 500)
    }
  }

  const scrollToTop = ({ element, to, duration }) => {
    let currentTime = 0
    const start = element.scrollTop
    const change = to - start
    const increment = 20
    // eslint-disable-next-line no-param-reassign,no-return-assign,max-params
    const easeInQuad = (t, b, c, d) => c * (t /= d) * t + b
    const smoothScroll = () => {
      currentTime += increment
      // eslint-disable-next-line no-param-reassign
      element.scrollTop = easeInQuad(currentTime, start, change, duration)
      if (currentTime < duration) {
        setTimeout(smoothScroll, increment)
      }
    }

    smoothScroll()
  }

  if (scrollButton) {
    const scrollElement = getScrollElement()
    const scroll = scrollToTop.bind(null, {
      element: scrollElement,
      to: 0,
      duration: 400
    })
    scrollButton.addEventListener('click', scroll)

    window.addEventListener('scroll', scrollEventCallback, { passive: true })
    toggleScrollButton(pageYOffset)

    subscribe.after(SCROLL_TO_TOP, scroll)
  }
}
